import React from "react";
import { Modal, Button } from 'react-bootstrap';
import View from './View'


export default class Example extends React.Component {
    constructor(props, context) {
      super(props, context);
  
      this.state = {
        smShow: false,
        lgShow: false,
      };
    }
  
    render() {
      let lgClose = () => this.setState({ lgShow: false });
  
      return (
        <>
        <Button variant="link" style={{color:this.props.color}} onClick={() => this.setState({ lgShow: true })}>Terms and Conditions</Button>
          <Modal
            size="lg"
            show={this.state.lgShow}
            onHide={lgClose}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <View />
            </Modal.Body>
          </Modal>
        </>
      );
    }
  }